import React, { FC, useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { doFetchCurrencyRate, doFetchProfile } from '../../actions/authAction';
import {
  getRaffleGroup,
  getPreVerifiedCollectionList,
} from '../../actions/kafairAction';
import { getCollectionHomepageAsync } from '../../actions/productAction';
import { CURRENCY_CODE } from '../../constants';
import { useScrollMemory } from '../../helpers/dom';
import AuthInterface, {
  UserDataInterface,
} from '../../interface/reducers/auth';
import {
  PopularBrands,
  BrowseAll,
  HomepageSlider,
  RaffleSection,
  PromoBannerBank,
  FlashSaleHomepage,
  HotProducts,
  ForYou,
  CollectionHero,
  CollectionSection,
  ShopTheseLook,
  KickAveNews,
  LuxuryConcierge,
  CollectionParent,
  CollectionParent2,
  CollectionLook,
} from './Section';

interface History {
  push: () => any;
  replace: () => any;
}

type HomepageAppProps = {
  history: History;
  category: string;
  isKickFairActive: boolean;
  isLogged: boolean;
  getCollectionHomepageAsync: (args: string) => any;
  fetchCurrencyRate: (payload) => any;
  getProfile: () => Promise<any>;
  getPreVerifiedCollectionList: () => Promise<any>;
  getRaffleGroup: () => Promise<any>;
  pre_verified_list: Array<Object>;
};

const HomepageContainer: FC<HomepageAppProps> = ({
  history,
  category,
  isKickFairActive = () => false,
  getRaffleGroup,
  getCollectionHomepageAsync,
  fetchCurrencyRate,
  getProfile,
  isLogged,
  raffleGroup,
  getPreVerifiedCollectionList,
  pre_verified_list,
  dataAuth
}) => {
  const [collectionList, setCollectionList] = useState([]);
  useScrollMemory();

  useEffect(() => {
    getRaffleGroup();
    localStorage.removeItem('collectionSortedBy');
    getPreVerifiedCollectionList()
      .then(() => getCollectionHomepageAsync(category))
      .then(({ value }) => {
        let { data } = value.data;
        setCollectionList(data);
      })
      .catch((e) => {
        getCollectionHomepageAsync(category);
        console.log(e);
      });

    if (isLogged) {
      getProfile().then((res) => {
        let code = res.value.data.country_code;
        const currencyCode = CURRENCY_CODE[code === 'IDN' ? 'IDN' : 'ETC'];
        try {
          fetchCurrencyRate(currencyCode)
        } catch (error) {
          fetchCurrencyRate(CURRENCY_CODE['IDN'])
        }
        
      });
    }
  }, []);

  interface ItemCollectionHomepage {
    ui_template: string;
    slug: string;
    name: string;
    default_images: Array<Object>;
    children: Array<Object>;
    categories: Array<Object>;
  }

  return (
    <div>
      {
        // Display sliders
      }
      <HomepageSlider history={history} category={category} dataAuth={dataAuth}/>
      {
        // Display dynamic raffle
      }
      {raffleGroup &&
        raffleGroup.length > 0 &&
        raffleGroup.map((item) => {
          return (
            <RaffleSection
              ticket_type={item.ticket_type}
              raffleTitle={item.title}
              query={item.query}
              color={item.color}
              history={history}
              category={category}
            />
          );
        })}
      {
        // Display flash sale
      }
      {isKickFairActive && (
        <FlashSaleHomepage category={category} history={history} />
      )}
      {
        // If category is handbags => display concierge section
      }
      {category === 'handbags' && (
        <LuxuryConcierge category={category} history={history} />
      )}
      {
        // Display hot products section
      }
      <HotProducts category={category} history={history} />
      {/* <KickAveNews
        category={category}
        history={history}
      /> */}
      {
        // Display for you section (comment out sementara untuk luxury. request from merchandise team)
      }
      {
        category !== 'handbags' && (
          <ForYou category={category} history={history} />
        )
      }
      {
        // Display promo banner bank
      }
      <PromoBannerBank dataCategory={category} history={history} />
      {/* <PromoBanner
        dataCategory={category}
        history={history}
      /> */}
      {/* <Accessories /> */}
      {/* <PopularBrands
        history={history}
        dataCategory={category}
      />
      <BrowseAll category={category} history={history} /> */}
      {/* <CollectionPage
        category={category}
        history={history}
        title={'LOUIS VUITTON SS21 COLLECTION'}
        slug={'louis-vuitton-ss21'}
      />
      <CollectionPage
        category={category}
        history={history}
        title={'NIKE Kobe 5 Protro “Bruce Lee”'}
        slug={'nike-kobe'}
      />
      <CollectionPage
        category={category}
        history={history}
        title={'ADIDAS NMD Hu “Extra Eye”'}
        slug={'nmd-hu'}
      />
      <CollectionPage
        category={category}
        history={history}
        title={"SNEAKERS ESSENTIALS"}
      />
      <CollectionSection
        category={category}
        history={history}
      />
      <ShopTheseLook
        category={category}
        history={history
        }
      /> */}
      {
        // Display dynamic collection list
      }
      {collectionList &&
        collectionList.length > 0 &&
        collectionList.map((item: ItemCollectionHomepage) => {
          // Display dynamic collections
          let { categories } = item;
          // Check image availability ==> Get from pivot
          let image =
            categories.length > 0 &&
            categories[0].pivot &&
            categories[0].pivot.images.length > 0 &&
            categories[0].pivot.images;
          // Find image landscape
          let imageLandscape =
            image.length > 0 &&
            image.find((item) => item.orientation === 'landscape');
          // Find image portrait
          let imagePortrait =
            image.length > 0 &&
            image.find((item) => item.orientation === 'portrait');

          // Check which collection only display pre-verified products
          const checkIsCollectionPreVerified =
            pre_verified_list &&
            pre_verified_list.find(
              (collection: Object) => collection.slug === item.slug,
            )
              ? true
              : false;

          if (item.ui_template == 'HERO') {
            // check if collection ui template => HERO then display hero collection
            return (
              <CollectionHero
                title={item.name}
                images={
                  window.screen.availWidth < 480
                    ? imagePortrait
                    : imageLandscape
                }
                slug={item.slug}
                category={category}
                history={history}
                isPreVerified={checkIsCollectionPreVerified}
              />
            );
          } else if (
            item.ui_template == 'PARENT' &&
            item.default_images.length <= 0
          ) {
            if (
              item.children.length > 0 &&
              item.children[0].ui_template == 'LOOK'
            ) {
              // check if collection ui template is look then display shop these looks collection
              return (
                <CollectionLook
                  title={item.name}
                  children={item.children}
                  category={category}
                  history={history}
                />
              );
            } else {
              // check if collection ui template is parent and default image not found then display parent type collection without image
              return (
                <CollectionParent
                  title={item.name}
                  images={
                    window.screen.availWidth < 480
                      ? imagePortrait
                      : imageLandscape
                  }
                  slug={item.slug}
                  category={category}
                  children={item.children}
                  history={history}
                  isPreVerified={checkIsCollectionPreVerified}
                />
              );
            }
          } else if (
            item.ui_template == 'PARENT' &&
            item.default_images.length > 0
          ) {
            // Check if collection ui template is parent and default image is found then display parent type collection with image
            return (
              <CollectionParent2
                title={item.name}
                images={
                  window.screen.availWidth < 480
                    ? imagePortrait
                    : imageLandscape
                }
                slug={item.slug}
                category={category}
                history={history}
                children={item.children}
                isPreVerified={checkIsCollectionPreVerified}
              />
            );
          }
        })}

      {
        // Display popular brands slider section
      }
      <PopularBrands history={history} category={category} />

      {/* <CollectionSection category={category} history={history} />
      <ShopTheseLook category={category} history={history} />
      <PopularBrands history={history} category={category} /> */}

      {
        // Display browse all section
      }
      <BrowseAll category={category} history={history} />
    </div>
  );
};

interface RaffleGroupData {
  data: Array<Object>;
}
interface isKickFairActive {
  isKickFairActive: boolean;
  raffleGroup: RaffleGroupData;
  pre_verified_list: Array<Object>;
}

interface State {
  dataKaFair: isKickFairActive;
  dataAuth: AuthInterface;
}

const mapStateToProps = (state: State) => ({
  isKickFairActive: state.dataKaFair.isKickFairActive,
  isLogged: state.dataAuth.isLogged,
  raffleGroup: state.dataKaFair.raffleGroup.data,
  pre_verified_list: state.dataKaFair.pre_verified_list.data,
  dataAuth: state.dataAuth
});

const mapDispatchToProps = (dispatch: any) => ({
  getRaffleGroup: () => dispatch(getRaffleGroup()),
  getCollectionHomepageAsync: (category: string) =>
    dispatch(getCollectionHomepageAsync(category)),
  fetchCurrencyRate: (payload) => dispatch(doFetchCurrencyRate(payload)),
  getProfile: () => dispatch(doFetchProfile()),
  getPreVerifiedCollectionList: () => dispatch(getPreVerifiedCollectionList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomepageContainer);
